export default __webpack_public_path__ + "static/media/linkedin.e6d9ad33.png";